<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div v-else class="disable-text-selection">
            <div class="top-right-button-container">
                <b-button @click="printInspection" size="sm" variant="primary">
                    Print
                </b-button>
            </div>


            <div class="d-flex flex-row mb-2">
                <span class="iconsminds-coins mr-3 menu-icon-style" style="font-size: 23px;"/>

                <piaf-breadcrumb :heading="inspection.data.attributes.code"/>

<!--                <p class="my-auto">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                    repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                    officiis quia quos rem totam vitae.-->
<!--                </p>-->
            </div>

            <div class="separator mb-4"/>

            <b-row class="invoice-vue" id="print-inspection">
                <b-colxx md="12">
                    <b-card no-body>
                        <b-card-body class="d-flex flex-column justify-content-between">
                            <div class="d-flex flex-column">
                                <div class="d-flex flex-row justify-content-between mb-5">
                                    <div class="d-flex flex-column w-70 mr-2 p-4 text-semi-muted bg-semi-muted">
                                        <p class="mb-0">Facility Name: {{
                                                inspection.data.attributes.facility_name
                                            }}e</p>
                                        <p class="mb-0">Address: {{ inspection.data.attributes.facility_address }}</p>
                                        <p class="mb-0">Inspector: {{ inspection.data.attributes.inspector }}</p>
                                    </div>

                                    <div class="d-flex w-30 flex-column text-right p-4 text-semi-muted bg-semi-muted">
                                        <p class="mb-0">Inspection Code: {{ inspection.data.attributes.code }}</p>
                                        <p class="mb-0">Inspection Type: {{ inspection.data.attributes.type }}</p>
                                        <p class="mb-0">Inspection Date: {{ inspection.data.attributes.date }}</p>
                                        <p class="mb-0">CAP Due Date: {{ inspection.data.attributes.cap_due }}</p>
                                    </div>
                                </div>

                                <div class="d-flex flex-row justify-content-center mb-3">
                                    <h4><u>DEFICIENCY DETAILS REPORT</u></h4>
                                </div>

                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="text-muted mb-2">#</th>
                                        <th class="text-muted mb-2">UNIT/CONTENT</th>
                                        <th class="text-muted mb-2">CONCERN</th>
                                        <th class="text-muted mb-2">CATEGORY</th>
                                        <th class="text-muted mb-2">DETAILS</th>
                                        <th class="text-muted mb-2">REMARKS</th>
                                        <th class="text-muted mb-2">WEIGHTAGE</th>
                                        <th class="text-muted mb-2">CORRECTIVE ACTION PLAN</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <tr v-for="(content, index) in inspection.data.attributes.contents.data">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ content.data.attributes.unit }}</td>
                                        <td>{{ content.data.attributes.concern }}</td>
                                        <td>{{ content.data.attributes.category }}</td>
                                        <td>{{ content.data.attributes.details }}</td>
                                        <td>{{ content.data.attributes.remarks }}</td>
                                        <td>{{ content.data.attributes.weightage }}</td>
                                        <td>{{ content.data.attributes.corrective_plan }}</td>
                                    </tr>

                                    <tr v-if="inspection.data.attributes.contents.data.length === 0">
                                        <td colspan="8" class="text-center">No deficiency recorded for this inspection.</td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div class="d-flex flex-column">
                                    <div class="border-bottom pt-3 mb-5"></div>
                                    <table class="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th class="text-muted mb-2">WEIGHTED DEFICIENCIES</th>
                                            <th class="text-muted mb-2">BOTH</th>
                                            <th class="text-muted mb-2">HEALTH</th>
                                            <th class="text-muted mb-2">SAFETY</th>
                                            <th class="text-muted mb-2">TOTAL DEFICIENCIES</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        <tr class="font-weight-semibold">
                                            <td>{{ inspection.data.attributes.outcome.total_weightage }}</td>
                                            <td>{{ inspection.data.attributes.outcome.concern_both }}</td>
                                            <td>{{ inspection.data.attributes.outcome.concern_health }}</td>
                                            <td>{{ inspection.data.attributes.outcome.concern_safety }}</td>
                                            <td>{{ inspection.data.attributes.outcome.total_deficiencies }}</td>
                                        </tr>
                                        </tbody>
                                    </table>

                                    <b-row>
                                        <b-colxx md="6">
                                            <table class="table table-bordered">
                                                <tbody>
                                                <tr>
                                                    <td>Total Number Of Inspection Area Inspected</td>
                                                    <td class="font-weight-semibold">{{ inspection.data.attributes.inspected_areas }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Weighted Average Deficiencies Per Inspected Area with Deficiencies</td>
                                                    <td class="font-weight-semibold">{{ inspection.data.attributes.outcome.average }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </b-colxx>

                                        <b-colxx md="6">
                                            <table class="table table-bordered">
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <p class="font-weight-bold">REMARKS:</p>
                                                        <p>{{ inspection.data.attributes.notes }}</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </b-colxx>
                                    </b-row>

                                    <b-row>
                                        <b-colxx md="6">
                                            <p class="font-weight-bold">Outcome: <span class="font-weight-semibold">{{ inspection.data.attributes.outcome.result }}</span></p>
                                            <table class="table table-bordered">
                                                <tbody>
                                                <tr class="text-center" >
                                                    <td colspan="2"><span class="font-weight-bold">Rating</span></td>
                                                </tr>
                                                <tr class="text-center" >
                                                    <td>Very Good</td>
                                                    <td>0</td>
                                                </tr>
                                                <tr class="text-center" >
                                                    <td>Good</td>
                                                    <td>0.01 - 3.0</td>
                                                </tr>
                                                <tr class="text-center" >
                                                    <td>Satisfactory</td>
                                                    <td>3.01 - 5.0</td>
                                                </tr>
                                                <tr class="text-center" >
                                                    <td>Unsatisfactory</td>
                                                    <td>5.01 - 10.0</td>
                                                </tr>
                                                <tr class="text-center" >
                                                    <td>Unacceptable</td>
                                                    <td> > 10.0 </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </b-colxx>

                                        <b-colxx md="6">
                                            <p class="font-weight-bold">Corrective Action Plan:</p>
                                            <table class="table table-bordered">
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        <p>{{ inspection.data.attributes.corrective_plan }}</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </b-colxx>
                                    </b-row>

                                    <div class="border-bottom pt-3 mb-5"></div>

                                    <p class="text-muted text-small text-center">
                                        Printed by: {{ inspection.data.attributes.printed_by }}, Printed at:
                                        {{ inspection.data.attributes.printed_at }}</p>
                                </div>
                            </div>
                        </b-card-body>
                    </b-card>
                </b-colxx>
            </b-row>

            <b-row class="mt-4 mb-n4" v-if="files.length > 0">
                <b-colxx md="12">
                    <div>
                        <div class="d-flex flex-row">
                            <div class="my-auto">
                                <div class="d-inline-block mb-3">
                                    <h5 class="d-inline">Attachments</h5>
                                </div>
                            </div>
                        </div>

                        <FilesList :files="files" @delete="deleteFile"/>

                        <FileDelete v-if="file" :file="file" :base-url="base_url" @updated="getFiles($route.params.inspection_id)"/>
                    </div>
                </b-colxx>
            </b-row>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import FilesList from "../../../../components/Listing/FilesList";
import FileDelete from "../../../../components/Modal/FileDelete";

export default {
    name: "InspectionSummary",

    components: {
        FilesList,
        FileDelete
    },

    data() {
        return {
            loading: true,
            loadingFiles: true,
            themeMode: localStorage.getItem('theme_selected_color').split(".")[0],
            base_url: '/api/hms/inspections/' + this.$route.params.inspection_id + '/attachments',
            file: null,
        }
    },

    computed: {
        ...mapGetters({
            inspection: 'getInspection',
            files: 'getInspectionFiles'
        })
    },

    mounted() {
        this.getInspection(this.$route.params.inspection_id);
        this.getFiles(this.$route.params.inspection_id);
    },

    methods: {
        async getInspection(inspection_id) {
            await this.$store.dispatch('fetchInspection', inspection_id)
                .catch(error => {
                    this.$router.push('/error');
                });

            return this.loading = false;
        },

        async getFiles(inspection_id) {
            await this.$store.dispatch('fetchInspectionFiles', inspection_id);

            return this.loadingFiles = false;
        },

        deleteFile(file) {
            this.file = file;

            setTimeout(() => {
                this.$bvModal.show('file_delete');
            }, 1);
        },

        printInspection() {
            this.$htmlToPaper('print-inspection');
        }
    }
}
</script>

<style scoped>

</style>
